import React from "react";
import styled from "styled-components";
import CompareToggle from "../CompareToggle/CompareToggle";
import { usePilotageRhStore } from "../../../store/usePilotageRhStore";

/** En-tête de section : titre h2 + toggle de comparaison */
const SectionHeader = ({ sectionId, title }) => {
    const on = usePilotageRhStore((s) => !!s.compare[sectionId]);
    const toggleCompare = usePilotageRhStore((s) => s.toggleCompare);

    return (
        <Head>
            <Title>{title}</Title>
            <CompareToggle on={on} onToggle={() => toggleCompare(sectionId)} />
        </Head>
    );
};

export default SectionHeader;

const Head = styled.div`
    display: flex;
    align-items: center;
    gap: 11px;
    margin-bottom: 13px;
`;

const Title = styled.h2`
    font-size: var(--prh-font-xl);
    font-weight: 600;
    color: var(--prh-ink);
    margin: 0;
`;
